<div
  class="input-field"
  [ngClass]="{
    'has-value': !!fieldControl?.value,
    'has-placeholder': !!placeholder,
    'has-column-layout': layoutDirection !== 'row'
  }"
>
  <label
    class="input-label field-label"
    [style.cursor]="'default'"
    [ngClass]="{
      'sr-text': hideLabel,
      disabled: fieldControl?.disabled
    }"
    [attr.for]="fieldId"
    [attr.type]="type"
    (click)="labelIcon && labelTooltip && showInfoTooltip($event)"
  >
    {{ label }}

    <i2g-icon *ngIf="labelIcon" class="icon label-icon" [icon]="labelIcon">
    </i2g-icon>
  </label>

  <div class="input-wrapper" [ngClass]="{ 'has-left-icon': !!leftIcon }">
    <i2g-icon *ngIf="leftIcon" class="icon" [icon]="leftIcon"> </i2g-icon>

    <input
      class="input"
      i2gInput
      [valueAlignment]="valueAlignment"
      tabindex="0"
      [i2gFocusable]="focusableTrigger$"
      [attr.type]="type"
      [attr.id]="fieldId"
      [attr.placeholder]="placeholder"
      [attr.maxlength]="maxlength <= 0 ? null : maxlength"
      autocorrect="off"
      autocapitalize="off"
      spellcheck="false"
      [formControl]="fieldControl"
      [attr.data-e2e-id]="e2eId"
      i2gTrackable
      [trackingObject]="trackingObject"
      [trackingAction]="trackingAction"
      [i2gAutoComplete]="autoCompleteOptions?.autoComplete"
      (blur)="inputBlur.emit(fieldControl.value)"
      (focus)="inputFocus.emit(fieldControl.value)"
      (keyup)="inputKeyup.emit($event)"
      (autoCompleteFetchStart)="autoCompleteFetchStart.emit()"
      (autoCompleteFetchEnd)="autoCompleteFetchEnd.emit($event)"
      (autoCompleteSet)="autoCompleteSet.emit($event)"
      (autoCompleteHide)="autoCompleteHide.emit()"
      (autoCompleteDestroy)="autoCompleteDestroy.emit()"
    />

    <i2g-icon
      *ngIf="rightIcon"
      class="icon right-icon"
      [icon]="rightIcon"
      (click)="inputRightIconClick.emit()"
    >
    </i2g-icon>

    <i2g-error-message
      [dirty]="fieldControl.dirty"
      [invalid]="fieldControl.invalid"
      [errorMessage]="errorMessage"
    >
    </i2g-error-message>

    <p *ngIf="description" class="description">
      {{ description }}
    </p>
  </div>
</div>
